import { ApolloClient } from "@apollo/client";
import { paramsGetClientesDsCloud, paramsSetEstadoCuentaPorSuscrip } from "../../../bussines/params/ClienteDsCloud.params";
import { ClienteDsCloud } from "../../../bussines/entities/clienteDsCloud.enity";
import { getClientesDsCloudGql, setEstadoCuentaPorSuscripGql } from "../gql/clienteDsCloud.gql";

export class ClientesDsCloudApolloProvider {
    private apolloClient: ApolloClient<object>;

    constructor(ApolloClient: ApolloClient<object>) {
        this.apolloClient = ApolloClient;
    }

    async getClientesDsCloud(variables: paramsGetClientesDsCloud): Promise<ClienteDsCloud[]> {
        try{
            const response = await this.apolloClient.query({
                variables,
                query: getClientesDsCloudGql
            });
            return response.data.clientesDsCloud;
        } catch (error) {
            throw error;
        }
    }
    async setEstadoCuentaPorSuscrip(variables: paramsSetEstadoCuentaPorSuscrip):Promise<string> {
        try{
            const response = await this.apolloClient.mutate({
                mutation: setEstadoCuentaPorSuscripGql,
                variables
            });
            return response.data.cambiarEstadoClientesDsCloud;
        } catch(error) {
            throw error;
        }
    }
}